import { render, staticRenderFns } from "./integralget.vue?vue&type=template&id=32d47b2f&scoped=true&"
import script from "./integralget.vue?vue&type=script&lang=js&"
export * from "./integralget.vue?vue&type=script&lang=js&"
import style0 from "./integralget.vue?vue&type=style&index=0&id=32d47b2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d47b2f",
  null
  
)

export default component.exports